import { render, staticRenderFns } from "./Category.vue?vue&type=template&id=2d283ca0&"
import script from "./Category.vue?vue&type=script&lang=js&"
export * from "./Category.vue?vue&type=script&lang=js&"
import style0 from "./Category.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/media/thed/vol_40/Laravel/bmat/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d283ca0')) {
      api.createRecord('2d283ca0', component.options)
    } else {
      api.reload('2d283ca0', component.options)
    }
    module.hot.accept("./Category.vue?vue&type=template&id=2d283ca0&", function () {
      api.rerender('2d283ca0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/category/Category.vue"
export default component.exports